import { render, staticRenderFns } from "./agreementConsult.vue?vue&type=template&id=ec86b51a&scoped=true&"
import script from "./agreementConsult.vue?vue&type=script&lang=js&"
export * from "./agreementConsult.vue?vue&type=script&lang=js&"
import style0 from "./agreementConsult.vue?vue&type=style&index=0&id=ec86b51a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec86b51a",
  null
  
)

export default component.exports